import React, { useState } from "react";
import PropTypes from "prop-types";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

import "../utils/pdfWorker";

const PdfViewer = (props) => {
  const { fileUrl } = props;
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = (pdfInfo) => {
    setNumPages(pdfInfo.numPages);
  };

  const previousPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full pb-10 flex-1 flex flex-col">
        <Document
          file={fileUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading="Ładowanie PDF..."
          className="flex justify-center flex-1 h-full"
        >
          <Page
            pageNumber={pageNumber}
            scale={0.5}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>

        <div className="flex items-center justify-between mt-4">
          <button
            onClick={previousPage}
            disabled={pageNumber <= 1}
            className="
              px-6 py-2 text-white text-sm
              bg-black hover:bg-primaryYellow
              disabled:bg-gray-200 disabled:text-gray-400
              enabled:cursor-pointer
              transition-colors
            "
          >
            Wcześniejszy slajd
          </button>
          <div className="flex items-center space-x-4">
            <p>
              Strona {pageNumber} z {numPages}
            </p>
          </div>
          <button
            onClick={nextPage}
            disabled={pageNumber >= numPages}
            className="
              px-6 py-2 text-white text-sm
              bg-black hover:bg-primaryYellow
              disabled:bg-gray-200 disabled:text-gray-400
              enabled:cursor-pointer
              transition-colors
            "
          >
            Następny slajd
          </button>
        </div>
      </div>
    </div>
  );
};

PdfViewer.propTypes = {
  fileUrl: PropTypes.string,
};

export default PdfViewer;
